import { mCookie } from '@mshark/base';
import { nativeApi } from '@dym/client-bridge';

const $SYS = window.$SYS || {};
let appCookieCount = 0;
let dyCookieCount = 0;

function getAppCsrf(callback) {
    if (mCookie.getItem($SYS.tvk)) {
        if (callback && typeof callback === 'function') {
            callback();
        }
    } else {
        nativeApi.jsNative.getUserToken({}, (res) => {
            const token = res.data || '';

            if (token && token.length > 20) {
                $.ajax({
                    url: `/h5nc/csrf/getCsrfCookie?token=${token}`,
                    type: 'get',
                    dataType: 'json',
                    success: () => {
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    },
                    error: () => {
                        appCookieCount += 1;
                        if (appCookieCount <= 9) {
                            getAppCsrf(callback);
                        }
                    }
                });
            }
        });
    }
}

function getDYCsrf(callback) {
    if (mCookie.getItem($SYS.tvk)) {
        if (callback && typeof callback === 'function') {
            callback();
        }
    } else {
        nativeApi.jsNative.getUserToken({}, (res) => {
            const token = res.data || '';

            if (token && token.length > 20) {
                $.ajax({
                    url: '/curl/csrfNlApi/getCsrfCookie',
                    type: 'get',
                    dataType: 'json',
                    success: () => {
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    },
                    error: () => {
                        dyCookieCount += 1;
                        if (dyCookieCount <= 9) {
                            getDYCsrf(callback);
                        }
                    }
                });
            }
        });
    }
}

export { getAppCsrf, getDYCsrf };
